import PageLoading from 'components/common/PageLoading';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const BASE_URL = '/privacy-and-data/data-stream';

const OAuthCallback = () => {
  const navigate = useNavigate();

  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);

    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (error) {
      navigate(`${BASE_URL}?oauth_error=${error}`, { replace: true });
      return;
    }

    if (code && state) {
      navigate(`${BASE_URL}?oauth_code=${code}&partner_id=${state}`, {
        replace: true,
      });
      return;
    }

    navigate(`${BASE_URL}?oauth_error=invalid_callback`, { replace: true });
  }, []);

  return <PageLoading />;
};

export default OAuthCallback;
